import BasicModal from '@/components/ui/BasicModal';
import React from 'react';
import { useTranslation } from 'next-i18next';
import CrashGameDetail from './CrashGameDetail';

interface DetailModalProps {
  isOpen: boolean;
  onClose: () => void;
  rowData: any; // Replace 'any' with the appropriate row data type
}

const DetailModal: React.FC<DetailModalProps> = ({
  isOpen,
  onClose,
  rowData,
}) => {
  const { t } = useTranslation();
  return (
    <BasicModal
      open={isOpen}
      onClose={onClose}
      title={t('Crash Game') as string}
    >
      <CrashGameDetail detail={rowData}></CrashGameDetail>
    </BasicModal>
  );
};

export default DetailModal;
